module.exports = __webpack_public_path__ + "img/aeroland-tab-content-image-04.1d62a970.png";